import axios from "axios";
import { SET_AUDIT_LOGS, SET_AUDIT_FILTERS } from "./types";
import { Toast } from "../../util/Toast";

export const getAuditLogs =
  ({ start, limit, search, module, action, startDate, endDate }) =>
  (dispatch) => {
    const params = new URLSearchParams();
    params.append("start", start || 1);
    params.append("limit", limit || 20);
    if (search) params.append("search", search);
    if (module) params.append("module", module);
    if (action) params.append("action", action);
    if (startDate) params.append("startDate", startDate);
    if (endDate) params.append("endDate", endDate);

    axios
      .get(`auditLog/logs?${params.toString()}`)
      .then((res) => {
        if (res.data.status) {
          dispatch({
            type: SET_AUDIT_LOGS,
            payload: { data: res.data.data, total: res.data.total },
          });
        } else {
          Toast("error", res.data.message);
        }
      })
      .catch((err) => {
        Toast("error", err.message);
      });
  };

export const getAuditFilters = () => (dispatch) => {
  axios
    .get("auditLog/filters")
    .then((res) => {
      if (res.data.status) {
        dispatch({
          type: SET_AUDIT_FILTERS,
          payload: { modules: res.data.modules, actions: res.data.actions },
        });
      }
    })
    .catch((err) => {
      console.error("Audit filters error:", err.message);
    });
};
